import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { PersonDeceasedCommandDataForm } from './PersonDeceasedCommandDataForm'

/**
 * Death is when a participant has died and the death date needs to be applied.
 *
 * @links
 * - [LegalEntity commands](@root/legalentity/legalentity-server/doc/solution/commands/LegalEntityCommands.md)
 * - @api legalentity-shared/PersonDeceasedCommandData, Person deceased command@
 * - @api legalentity-shared/PartnerDeceasedCommandData, Partner deceased command@
 */
export function PersonDeceasedCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.crm.useDeathActions')({
    personId: ownerId,
    tenantId,
    ...props,
  })
  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="legalEntity.PersonDeceasedCommandData"
      title={translate('deathButton.title')}
      commandDataForm={PersonDeceasedCommandDataForm}
      {...props}
      submit={submit}
    />
  )
}
